// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"1f0fa700","540":"b8580362","787":"1d74ac3b"}[chunkId] + ".chunk.js";
};